import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormArray, FormBuilder, FormGroup } from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { fromEvent } from "rxjs";
import { debounceTime, distinctUntilChanged, tap } from "rxjs/operators";

import { Pagination } from "../../coletor/coletor";
import { TecidoList } from "../tecido";
import { TecidoStore } from "../tecido.store";
import { TecidosCaptadosService } from "../tecidos-captados.service";

interface TecidoArray {
  tecidos: FormArray;
  tecidos2: TecidoList[];
}

@Component({
  selector: "app-tecidos",
  templateUrl: "./tecidos.component.html",
  styleUrls: ["./tecidos.component.css"],
})
export class TecidosComponent implements OnInit {
  public tecidosForm: FormGroup;
  result: string = "";
  horizontalPosition: MatSnackBarHorizontalPosition = "center";
  verticalPosition: MatSnackBarVerticalPosition = "top";

  constructor(
    private tecidoService: TecidosCaptadosService,
    public store: TecidoStore,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<TecidosComponent>,
    private tecidosModal: MatDialog,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: TecidoArray
  ) {}

  adicionarTecido(tecido) {
    this.store.relacionado = [...this.store.relacionado, tecido];

    this.store.tecidos = this.store.tecidos.filter(
      (tec) => tec.codigo !== tecido.codigo
    );

    this.data.tecidos.push(
      this.fb.group({
        codigo: tecido.codigo,
        nome: tecido.nome,
        acao: "Inserir",
        codigoCaptacao: null,
      })
    );

    this.data.tecidos2.push({
      codigo: tecido.codigo,
      nome: tecido.nome,
      grupo: tecido.grupo,
      sitio: tecido.sitio,
      relacionado: tecido.relacionado,
      acao: "Inserir",
      codigoCaptacao: tecido.codigoCaptacao,
    });

    this.data.tecidos2;
    this.openSnackBar("Tecido adicionado com sucesso!", "Fechar");
  }

  //colunas: string[] = ['id','nome'];
  // dataSource: MatTableDataSource<TecidoList>;
  //selection = new SelectionModel<TecidoList>(true, []);
  //pageSizeArray: number[] = [5,10,20,30,50,100];

  // @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild("input", { static: true }) input: ElementRef;

  ngOnInit(): void {
    this.tecidoService
      .findAll("50", "0", "")
      .subscribe((res: Pagination<TecidoList[]>) => {
        this.store.tecidos = res.results.filter(
          ({ codigo: codigo1 }) =>
            !this.store.relacionado.some(
              ({ codigo: codigo2 }) => codigo2 === codigo1
            )
        );
      });
  }

  ngAfterViewInit() {
    fromEvent(this.input.nativeElement, "keyup")
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        tap((text) => {
          this.tecidoService
            .findAll("50", "0", this.input.nativeElement.value)
            .subscribe((res: Pagination<TecidoList[]>) => {
              this.store.tecidos = res.results;
              this.store.pageLenght = res.total;
              this.store.pageSearch = this.input.nativeElement.value;
            });
        })
      )
      .subscribe();
  }

  closeModal() {
    this.tecidosModal.closeAll();
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3000,
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
    });
  }
}
